import * as React from 'react';

import { ValuationFilters } from '../../components/ValuationFilters';
import { MainFiltersWidgetContainer } from '../MainFiltersWidgetContainer';
import { ValuationFiltersSubmitContainer } from '../ValuationFiltersSubmitContainer';
import { useIsReportStatusDefault } from '../../utils/report';
import { useUpdateSidebarMenu } from './utils/useUpdateSidebarMenu';
import { useBannerName } from '../HeroBannerContainer/utils/useBannerName';
import { TRefWrapper } from '../Scrolling';
import { HeroBannerContainer } from '../HeroBannerContainer';
import { useIsSearcherFromOfferCard } from '../../utils/report/useIsSearcherFromOfferCard';

interface IValuationFiltersContainerProps {
  refWrapper: TRefWrapper;
}

export function ValuationFiltersContainer({ refWrapper }: IValuationFiltersContainerProps) {
  const isReportStatusDefault = useIsReportStatusDefault();
  const isSearcherFromOfferCard = useIsSearcherFromOfferCard();
  const backgroundFor = useBannerName();

  useUpdateSidebarMenu();

  if (!isReportStatusDefault || isSearcherFromOfferCard) {
    return null;
  }

  return (
    <ValuationFilters
      backgroundFor={backgroundFor}
      mainFiltersWidget={<MainFiltersWidgetContainer />}
      valuationFiltersSubmit={<ValuationFiltersSubmitContainer />}
      heroBanner={<HeroBannerContainer />}
      refWrapper={refWrapper}
    />
  );
}
